import type { ReactNode } from 'react'
import { Modal } from '@tinkern/ui'

interface LifeModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  children: ReactNode
}

export default function LifeModal({ isOpen, onClose, title, size = 'lg', children }: LifeModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      containerClassName="bg-navy-900/95 backdrop-blur-md border border-amber-400/30 rounded-xl shadow-2xl"
      headerClassName="border-b border-amber-400/20"
      titleClassName="text-2xl font-heading font-semibold text-amber-100"
      closeButtonClassName="text-amber-200/70 hover:text-amber-100 p-1 rounded-lg hover:bg-amber-400/10 transition-colors"
    >
      {children}
    </Modal>
  )
}
